import { BN_MAP } from "../app/app.constants";

export function capitalize(value: string) {
  let capitalizedText = "";
  const conjunctions = [
    "an",
    "a",
    "the",
    "of",
    "and",
    "but",
    "for",
    "nor",
    "or",
    "so",
    "yet",
    "in",
    "on",
    "at",
    "to",
    "by",
    "with",
  ];

  const textArray = value?.split(" ");

  for (let i = 0; i < textArray?.length; i++) {
    const word = textArray[i];
    if (i === 0 || word?.endsWith(".")) {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    } else if (conjunctions?.includes(word?.toLowerCase())) {
      capitalizedText += word?.toLowerCase() + " ";
    } else {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    }
  }

  return capitalizedText?.trim();
}

// export function slug(value?: string): string | undefined {
//   if (!value) return value;

//   const timestamp = Date.now().toString(36);
//   const random = Math.floor(100 + Math.random() * 900);

//   const baseSlug = value
//     .toLowerCase()
//     .trim()
//     // allow bangla + english + numbers + space + hyphen
//     .replace(/[^\u0980-\u09FFa-z0-9\s-]/g, "")
//     .replace(/\s+/g, "-");

//   return `${baseSlug}-${timestamp}-${random}`;
// }

export function slug(value?: string): string | undefined {
  if (!value) return value;

  const timestamp = Date.now().toString(36);
  const random = Math.floor(100 + Math.random() * 900);

  const transliterated = value
    .split("")
    .map((char) => BN_MAP[char] ?? char)
    .join("");

  const baseSlug = transliterated
    .toLowerCase()
    .trim()
    // ❗ ONLY english letters, numbers, space & hyphen
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

  return `${baseSlug}-${timestamp}-${random}`;
}
